/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface GetOrganizationPayments200ResponseInner
 */
export interface GetOrganizationPayments200ResponseInner {
    /**
     * 
     * @type {number}
     * @memberof GetOrganizationPayments200ResponseInner
     */
    'amount': number | null;
    /**
     * 
     * @type {number}
     * @memberof GetOrganizationPayments200ResponseInner
     */
    'pointAmount': number | null;
    /**
     * 
     * @type {string}
     * @memberof GetOrganizationPayments200ResponseInner
     */
    'type': GetOrganizationPayments200ResponseInnerTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof GetOrganizationPayments200ResponseInner
     */
    'supplierName': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetOrganizationPayments200ResponseInner
     */
    'paymentDate': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetOrganizationPayments200ResponseInner
     */
    'registeredAt': string;
    /**
     * 
     * @type {boolean}
     * @memberof GetOrganizationPayments200ResponseInner
     */
    'isError': boolean;
    /**
     * 
     * @type {string}
     * @memberof GetOrganizationPayments200ResponseInner
     */
    'status': GetOrganizationPayments200ResponseInnerStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof GetOrganizationPayments200ResponseInner
     */
    'fileName': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetOrganizationPayments200ResponseInner
     */
    'fileExtension': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetOrganizationPayments200ResponseInner
     */
    'bankAccountActivityId': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetOrganizationPayments200ResponseInner
     */
    'billId': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetOrganizationPayments200ResponseInner
     */
    'usageFeeId': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetOrganizationPayments200ResponseInner
     */
    'cardBillId': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetOrganizationPayments200ResponseInner
     */
    'serviceChargeId': string | null;
}

export const GetOrganizationPayments200ResponseInnerTypeEnum = {
    payBill: 'PAY_BILL',
    usageFee: 'USAGE_FEE',
    card: 'CARD',
    serviceCharge: 'SERVICE_CHARGE'
} as const;

export type GetOrganizationPayments200ResponseInnerTypeEnum = typeof GetOrganizationPayments200ResponseInnerTypeEnum[keyof typeof GetOrganizationPayments200ResponseInnerTypeEnum];
export const GetOrganizationPayments200ResponseInnerStatusEnum = {
    uploaded: 'UPLOADED',
    readCompleted: 'READ_COMPLETED',
    awaitingApproval: 'AWAITING_APPROVAL',
    approved: 'APPROVED',
    transferCompleted: 'TRANSFER_COMPLETED',
    readError: 'READ_ERROR',
    insufficientBalance: 'INSUFFICIENT_BALANCE',
    transferFailed: 'TRANSFER_FAILED',
    approvalExpired: 'APPROVAL_EXPIRED',
    approvalRejected: 'APPROVAL_REJECTED',
    otherError: 'OTHER_ERROR',
    pending: 'PENDING',
    canceled: 'CANCELED',
    reserved: 'RESERVED',
    requestingExternalAccountTransfer: 'REQUESTING_EXTERNAL_ACCOUNT_TRANSFER',
    completed: 'COMPLETED'
} as const;

export type GetOrganizationPayments200ResponseInnerStatusEnum = typeof GetOrganizationPayments200ResponseInnerStatusEnum[keyof typeof GetOrganizationPayments200ResponseInnerStatusEnum];


